import modifyTemplate from '#shared/util/modifyTemplate.js';

import defaultProduct from '#themes/default/default/components/product/product.js';

import cButton from '#themes/default/web/components/button/button.js';
import cQuantity from '#themes/default/web/components/quantity/quantity.js';
import cSelect from '#themes/default/web/components/select/select.js';
import cSkeleton from '#themes/default/web/components/skeleton/skeleton.js';
import cSvg from '#themes/default/web/components/svg/svg.js';
import cTooltip from '#themes/default/web/components/tooltip/tooltip.js';
import defaultTemplate from '#themes/default/default/components/product/product.html' with { type: 'html' };

import productActivationStatusTemplate from './html/product_activationStatus.html' with { type: 'html' };
import productInstructionsTemplate from './html/product_instructions.html' with { type: 'html' };

const template = modifyTemplate(defaultTemplate, [{
	query: '.product_activationStatus',
	position: 'replace',
	content: productActivationStatusTemplate
}, {
	query: '.product_instructions',
	position: 'replace',
	content: productInstructionsTemplate
}]);

export default {
	components: {
		cButton,
		cQuantity,
		cSelect,
		cSkeleton,
		cSvg,
		cTooltip
	},
	extends: defaultProduct,
	data() {
		return {
			activationCodeCopied: false
		};
	},
	computed: {
		customizedInstaller() {
			let fulfillmentItem;
			if (this.hasFulfillment) {
				fulfillmentItem = this.product.fulfillment.license.find((item) => item.contentType === 'customizedinstaller');
			}
			return fulfillmentItem ? fulfillmentItem.content : null;
		},
		downloadLink() {
			let fulfillmentItem;
			if (this.hasFulfillment) {
				fulfillmentItem = this.product.fulfillment.license.find((item) => ['regularinstaller', 'customizedinstaller'].includes(item.contentType));
				if (fulfillmentItem && window.screen.width < 1024) {
					return 'https://help.avast.com/install';
				}
			}
			return fulfillmentItem ? fulfillmentItem.content : null;
		},
		licenseKey() {
			let fulfillmentItem;
			if (this.hasFulfillment) {
				fulfillmentItem = this.product.fulfillment.license.find((item) => ['walletkey', 'activationkey'].includes(item.contentType));
			}
			return fulfillmentItem ? fulfillmentItem.content : null;
		},
		isAutoActivationSupported() {
			return this.licenseKey && this.product.isBrowser;
		}
	},
	methods: {
		copyToClipboard(value) {
			const element = document.createElement('textarea');
			element.value = value;
			document.body.appendChild(element);
			element.select();
			document.execCommand('copy');
			document.body.removeChild(element);
			this.activationCodeCopied = true;
			setTimeout(() => {
				this.activationCodeCopied = false;
			}, 1000);
		}
	},
	template
};
